import { ILabelValuePair } from 'types/shared';

const Tracks = {
  value: 'track',
  label: 'Tracks',
};
const Releases = {
  value: 'release',
  label: 'Releases',
};
const Artists = {
  value: 'artist',
  label: 'Artists',
};
const Projects = {
  value: 'project',
  label: 'Projects',
};
const Labels = {
  value: 'label',
  label: 'Labels',
};
const Versions = {
  value: 'version',
  label: 'Versions',
};

export const getEntityTypes = (
  isExternalUser: boolean,
  tableName?: string
): ILabelValuePair<string>[] => {
  if (tableName === 'Browse Opus Release') {
    return isExternalUser
      ? [Versions, Tracks, Projects]
      : [Versions, Tracks, Projects, Labels];
  }
  if (tableName === 'Browse Opus Project') {
    return [Tracks, Releases];
  }
  if (tableName === 'Browse Opus Label') {
    return [Tracks, Releases, Projects, Artists];
  }
  if (tableName === 'Browse Opus Artist') {
    return isExternalUser
      ? [Tracks, Releases, Projects]
      : [Tracks, Releases, Projects, Labels];
  }
  if (tableName === 'Browse Opus Track') {
    return isExternalUser
      ? [Versions, Releases, Projects]
      : [Versions, Releases, Projects, Labels];
  }
  return isExternalUser
    ? [Tracks, Releases, Artists, Projects]
    : [Tracks, Releases, Artists, Projects, Labels];
};

const entityTypes: ILabelValuePair<string>[] = [
  {
    value: 'track',
    label: 'Tracks',
  },
  {
    value: 'release',
    label: 'Releases',
  },
  {
    value: 'artist',
    label: 'Artists',
  },
  {
    value: 'project',
    label: 'Projects',
  },
  {
    value: 'label',
    label: 'Labels',
  },
];

export default entityTypes;
